import { render, staticRenderFns } from "./EventStats.vue?vue&type=template&id=22d21f06"
import script from "./EventStats.vue?vue&type=script&lang=js"
export * from "./EventStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports